// notification.js
let notifyFunction = null

export function setNotifyFunction (fn) {
  notifyFunction = fn
}

export function notify (message, type = 'success', duration = 5) {
  if (notifyFunction) {
    notifyFunction(message, type, duration)
  } else {
    console.warn('Notification function is not set')
  }
}
